"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppId;
(function (AppId) {
    AppId["SkyBox"] = "SKY_BOX";
    AppId["SkyGoAndroidMobile"] = "SKY_GO_ANDROID_MOBILE";
    AppId["SkyGoIos"] = "SKY_GO_IOS";
    AppId["SkyGoWeb"] = "SKY_GO_WEB";
    AppId["SkyPod"] = "SKY_POD";
    AppId["TvGuideWeb"] = "TV_GUIDE_WEB";
    AppId["TvGuideAndroidMobile"] = "TV_GUIDE_ANDROID_MOBILE";
    AppId["TvGuideIos"] = "TV_GUIDE_IOS";
})(AppId = exports.AppId || (exports.AppId = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["Flat"] = "FLAT";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["Monthly"] = "MONTHLY";
})(BillingFrequency = exports.BillingFrequency || (exports.BillingFrequency = {}));
var ShowType;
(function (ShowType) {
    ShowType["Series"] = "SERIES";
    ShowType["Sport"] = "SPORT";
})(ShowType = exports.ShowType || (exports.ShowType = {}));
var EpisodeType;
(function (EpisodeType) {
    EpisodeType["Regular"] = "REGULAR";
    EpisodeType["Highlight"] = "HIGHLIGHT";
})(EpisodeType = exports.EpisodeType || (exports.EpisodeType = {}));
var EpisodeImageType;
(function (EpisodeImageType) {
    /** Bare image only */
    EpisodeImageType["Standard"] = "STANDARD";
    /** Includes additional metadata baked into the image, intended when the episodes is displayed outside of the context of it's parent */
    EpisodeImageType["ShowOverlay"] = "SHOW_OVERLAY";
})(EpisodeImageType = exports.EpisodeImageType || (exports.EpisodeImageType = {}));
var SportsProgramType;
(function (SportsProgramType) {
    SportsProgramType["Regular"] = "REGULAR";
    SportsProgramType["Highlight"] = "HIGHLIGHT";
})(SportsProgramType = exports.SportsProgramType || (exports.SportsProgramType = {}));
var StandardAspectRatio;
(function (StandardAspectRatio) {
    /**  Landscape  */
    StandardAspectRatio["_16_9"] = "_16_9";
    /**  Portrait  */
    StandardAspectRatio["_2_3"] = "_2_3";
    /**  Square  */
    StandardAspectRatio["_1_1"] = "_1_1";
})(StandardAspectRatio = exports.StandardAspectRatio || (exports.StandardAspectRatio = {}));
var AppsGroupPresentation;
(function (AppsGroupPresentation) {
    AppsGroupPresentation["Small"] = "SMALL";
    AppsGroupPresentation["Large"] = "LARGE";
})(AppsGroupPresentation = exports.AppsGroupPresentation || (exports.AppsGroupPresentation = {}));
var GroupLayout;
(function (GroupLayout) {
    GroupLayout["RailLandscape"] = "RAIL_LANDSCAPE";
    GroupLayout["RailPortrait"] = "RAIL_PORTRAIT";
    GroupLayout["Grid"] = "GRID";
    GroupLayout["ContinueWatching"] = "CONTINUE_WATCHING";
    GroupLayout["FavouriteApps"] = "FAVOURITE_APPS";
})(GroupLayout = exports.GroupLayout || (exports.GroupLayout = {}));
var ContentType;
(function (ContentType) {
    /** A show of type SERIES */
    ContentType["ShowSeries"] = "SHOW_SERIES";
    ContentType["Show"] = "SHOW";
    /** A show of type SPORT */
    ContentType["ShowSport"] = "SHOW_SPORT";
    ContentType["Episode"] = "EPISODE";
    ContentType["Movie"] = "MOVIE";
    ContentType["Channel"] = "CHANNEL";
    ContentType["PpvEvent"] = "PPV_EVENT";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var CollectionCustomerOption;
(function (CollectionCustomerOption) {
    CollectionCustomerOption["FilterByOnlyMyContent"] = "FILTER_BY_ONLY_MY_CONTENT";
    CollectionCustomerOption["FilterByViewingContext"] = "FILTER_BY_VIEWING_CONTEXT";
    CollectionCustomerOption["Sort"] = "SORT";
})(CollectionCustomerOption = exports.CollectionCustomerOption || (exports.CollectionCustomerOption = {}));
var CollectionOrder;
(function (CollectionOrder) {
    CollectionOrder["Newest"] = "NEWEST";
    CollectionOrder["Alphabetical"] = "ALPHABETICAL";
})(CollectionOrder = exports.CollectionOrder || (exports.CollectionOrder = {}));
var IconImageVariant;
(function (IconImageVariant) {
    IconImageVariant["Resting"] = "RESTING";
    IconImageVariant["Hover"] = "HOVER";
    IconImageVariant["Active"] = "ACTIVE";
})(IconImageVariant = exports.IconImageVariant || (exports.IconImageVariant = {}));
/**
 * We publish a set of predefined section identifiers, which allow a client to identify or request a known
 * section, for example when binding controls on a remote control to open a particular section.
 */
var PredefinedSectionId;
(function (PredefinedSectionId) {
    PredefinedSectionId["Home"] = "HOME";
    PredefinedSectionId["Browse"] = "BROWSE";
    PredefinedSectionId["MyApps"] = "MY_APPS";
    PredefinedSectionId["MyHub"] = "MY_HUB";
    PredefinedSectionId["TvGuide"] = "TV_GUIDE";
    PredefinedSectionId["WatchTv"] = "WATCH_TV";
    PredefinedSectionId["Planner"] = "PLANNER";
})(PredefinedSectionId = exports.PredefinedSectionId || (exports.PredefinedSectionId = {}));
var SectionNavAlignment;
(function (SectionNavAlignment) {
    SectionNavAlignment["Top"] = "TOP";
    SectionNavAlignment["Bottom"] = "BOTTOM";
})(SectionNavAlignment = exports.SectionNavAlignment || (exports.SectionNavAlignment = {}));
var VideoAssetEncoding;
(function (VideoAssetEncoding) {
    VideoAssetEncoding["Dash"] = "DASH";
    VideoAssetEncoding["Hls"] = "HLS";
})(VideoAssetEncoding = exports.VideoAssetEncoding || (exports.VideoAssetEncoding = {}));
var CustomerPayPerViewOfferFilter;
(function (CustomerPayPerViewOfferFilter) {
    CustomerPayPerViewOfferFilter["All"] = "ALL";
    CustomerPayPerViewOfferFilter["AvailableToPurchase"] = "AVAILABLE_TO_PURCHASE";
})(CustomerPayPerViewOfferFilter = exports.CustomerPayPerViewOfferFilter || (exports.CustomerPayPerViewOfferFilter = {}));
var EpisodeSort;
(function (EpisodeSort) {
    /**
     * Earliest episodes first. For entertainment shows, earliers is season then episode number ordering,
     * for sport it is the schedule start date (in lieu of a proper event/fixture date)
     */
    EpisodeSort["Earliest"] = "EARLIEST";
    /** As EARLIEST but in descending order */
    EpisodeSort["Latest"] = "LATEST";
    EpisodeSort["EpisodeNumberDescending"] = "EPISODE_NUMBER_DESCENDING";
})(EpisodeSort = exports.EpisodeSort || (exports.EpisodeSort = {}));
var SlotOrder;
(function (SlotOrder) {
    /**
     * Episodes can air out of order, particular if repeat airings are involved.
     * This will return slots in the natural order of the programmes they contain
     * eg S1E1, S1E2, S1E1, S2E1, reglardess of the slot date.
     */
    SlotOrder["EarliestProgramme"] = "EARLIEST_PROGRAMME";
    /** Order by slot start time, eg 1pm, 2pm, 3pm */
    SlotOrder["EarliestSlot"] = "EARLIEST_SLOT";
})(SlotOrder = exports.SlotOrder || (exports.SlotOrder = {}));
var PlaybackStreamType;
(function (PlaybackStreamType) {
    PlaybackStreamType["VAST"] = "VAST";
    PlaybackStreamType["MANIFEST"] = "MANIFEST";
})(PlaybackStreamType = exports.PlaybackStreamType || (exports.PlaybackStreamType = {}));
var DrmType;
(function (DrmType) {
    DrmType["Widevine"] = "WIDEVINE";
    DrmType["Playready"] = "PLAYREADY";
    DrmType["Fairplay"] = "FAIRPLAY";
})(DrmType = exports.DrmType || (exports.DrmType = {}));
var DeviceFamily;
(function (DeviceFamily) {
    DeviceFamily["Handset"] = "HANDSET";
    DeviceFamily["Tablet"] = "TABLET";
    DeviceFamily["Tv"] = "TV";
    DeviceFamily["Browser"] = "BROWSER";
    DeviceFamily["Unknown"] = "UNKNOWN";
})(DeviceFamily = exports.DeviceFamily || (exports.DeviceFamily = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["UNKNOWN"] = "UNKNOWN";
    DeviceType["PHONE"] = "PHONE";
    DeviceType["TABLET"] = "TABLET";
    DeviceType["COMPUTER"] = "COMPUTER";
    DeviceType["TV"] = "TV";
    DeviceType["POD"] = "POD";
    DeviceType["BOX"] = "BOX";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var SignOutDeviceType;
(function (SignOutDeviceType) {
    SignOutDeviceType["WEB"] = "WEB";
    SignOutDeviceType["MOBILE"] = "MOBILE";
    SignOutDeviceType["POD"] = "POD";
    SignOutDeviceType["BOX"] = "BOX";
})(SignOutDeviceType = exports.SignOutDeviceType || (exports.SignOutDeviceType = {}));
var SkyCustomerAccountStatus;
(function (SkyCustomerAccountStatus) {
    SkyCustomerAccountStatus["Active"] = "ACTIVE";
    SkyCustomerAccountStatus["Suspended"] = "SUSPENDED";
    SkyCustomerAccountStatus["Former"] = "FORMER";
})(SkyCustomerAccountStatus = exports.SkyCustomerAccountStatus || (exports.SkyCustomerAccountStatus = {}));
var ParentalControl;
(function (ParentalControl) {
    ParentalControl["Enabled"] = "ENABLED";
    ParentalControl["Disabled"] = "DISABLED";
    ParentalControl["NotSet"] = "NOT_SET";
})(ParentalControl = exports.ParentalControl || (exports.ParentalControl = {}));
var RecordType;
(function (RecordType) {
    RecordType["Episode"] = "EPISODE";
    RecordType["Series"] = "SERIES";
})(RecordType = exports.RecordType || (exports.RecordType = {}));
var CustomerPurchaseState;
(function (CustomerPurchaseState) {
    CustomerPurchaseState["Expired"] = "EXPIRED";
    CustomerPurchaseState["Reversed"] = "REVERSED";
    CustomerPurchaseState["Active"] = "ACTIVE";
})(CustomerPurchaseState = exports.CustomerPurchaseState || (exports.CustomerPurchaseState = {}));
var CustomerPurchaseEventType;
(function (CustomerPurchaseEventType) {
    CustomerPurchaseEventType["Purchase"] = "PURCHASE";
    CustomerPurchaseEventType["ReversePurchase"] = "REVERSE_PURCHASE";
    CustomerPurchaseEventType["Watched"] = "WATCHED";
})(CustomerPurchaseEventType = exports.CustomerPurchaseEventType || (exports.CustomerPurchaseEventType = {}));
/** @Deprecated use NzBsaClassification */
var Classification;
(function (Classification) {
    Classification["G"] = "_G";
    Classification["Pg"] = "_PG";
    Classification["M"] = "_M";
    Classification["_16"] = "_16";
    Classification["_18"] = "_18";
})(Classification = exports.Classification || (exports.Classification = {}));
var OverlayPosition;
(function (OverlayPosition) {
    OverlayPosition["TopLeft"] = "TOP_LEFT";
    OverlayPosition["TopRight"] = "TOP_RIGHT";
    OverlayPosition["Center"] = "CENTER";
    OverlayPosition["BottomLeft"] = "BOTTOM_LEFT";
    OverlayPosition["BottomRight"] = "BOTTOM_RIGHT";
})(OverlayPosition = exports.OverlayPosition || (exports.OverlayPosition = {}));
var NzCoAgeRating;
(function (NzCoAgeRating) {
    NzCoAgeRating["G"] = "_G";
    NzCoAgeRating["Pg"] = "_PG";
    NzCoAgeRating["M"] = "_M";
    NzCoAgeRating["_13"] = "_13";
    NzCoAgeRating["Rp13"] = "_RP13";
    NzCoAgeRating["R13"] = "_R13";
    NzCoAgeRating["_15"] = "_15";
    NzCoAgeRating["Rp15"] = "_RP15";
    NzCoAgeRating["R15"] = "_R15";
    NzCoAgeRating["_16"] = "_16";
    NzCoAgeRating["R"] = "_R";
    NzCoAgeRating["Rp16"] = "_RP16";
    NzCoAgeRating["R16"] = "_R16";
    NzCoAgeRating["_18"] = "_18";
    NzCoAgeRating["Rp18"] = "_RP18";
    NzCoAgeRating["R18"] = "_R18";
})(NzCoAgeRating = exports.NzCoAgeRating || (exports.NzCoAgeRating = {}));
var NzBsaClassification;
(function (NzBsaClassification) {
    NzBsaClassification["G"] = "_G";
    NzBsaClassification["Pg"] = "_PG";
    NzBsaClassification["M"] = "_M";
    NzBsaClassification["_16"] = "_16";
    NzBsaClassification["_18"] = "_18";
})(NzBsaClassification = exports.NzBsaClassification || (exports.NzBsaClassification = {}));
var NzBsaAudienceAdvisory;
(function (NzBsaAudienceAdvisory) {
    NzBsaAudienceAdvisory["C"] = "C";
    NzBsaAudienceAdvisory["L"] = "L";
    NzBsaAudienceAdvisory["V"] = "V";
    NzBsaAudienceAdvisory["S"] = "S";
})(NzBsaAudienceAdvisory = exports.NzBsaAudienceAdvisory || (exports.NzBsaAudienceAdvisory = {}));
var ViewingContext;
(function (ViewingContext) {
    ViewingContext["Vod"] = "VOD";
    ViewingContext["Catchup"] = "CATCHUP";
    ViewingContext["Download"] = "DOWNLOAD";
    ViewingContext["Tvod"] = "TVOD";
    ViewingContext["Linear"] = "LINEAR";
    ViewingContext["Ppv"] = "PPV";
})(ViewingContext = exports.ViewingContext || (exports.ViewingContext = {}));
var ProductCode;
(function (ProductCode) {
    ProductCode["Neon"] = "NEON";
    ProductCode["SkyBox"] = "SKY_BOX";
    ProductCode["SkyPod"] = "SKY_POD";
    ProductCode["SkyGo"] = "SKY_GO";
    ProductCode["Sky"] = "SKY";
})(ProductCode = exports.ProductCode || (exports.ProductCode = {}));
var CatalogCreditRole;
(function (CatalogCreditRole) {
    CatalogCreditRole["Actor"] = "ACTOR";
    CatalogCreditRole["Contestant"] = "CONTESTANT";
    CatalogCreditRole["Director"] = "DIRECTOR";
    CatalogCreditRole["ExecutiveProducer"] = "EXECUTIVE_PRODUCER";
    CatalogCreditRole["Host"] = "HOST";
    CatalogCreditRole["Judge"] = "JUDGE";
    CatalogCreditRole["Narrator"] = "NARRATOR";
    CatalogCreditRole["Producer"] = "PRODUCER";
    CatalogCreditRole["Self"] = "SELF";
    CatalogCreditRole["Voice"] = "VOICE";
})(CatalogCreditRole = exports.CatalogCreditRole || (exports.CatalogCreditRole = {}));
var PinType;
(function (PinType) {
    PinType["PARENTAL_RATING"] = "PARENTAL_RATING";
    PinType["ACCOUNT"] = "ACCOUNT";
})(PinType = exports.PinType || (exports.PinType = {}));
//# sourceMappingURL=index.js.map